<template>
  <div>
    <el-container>
      <el-header class="other-list-header">
       
        <div style="text-align:center;">
          <span>查询条件：</span>
          <el-input
            style="width:45%; margin:20px auto;"
            placeholder="请输入关键字"
            v-model="searchText"
            size="mini"
          ></el-input>
          <el-button type="primary" size="mini" @click="listSearch()">查询</el-button>
        </div>
      </el-header>
      <el-container>
        <el-main class="other-list-main" style="height:100%">
          <el-table :data="listData.list" border style="width: 100%">
            <el-table-column label="排序号" width="70">
              <template slot-scope="scope">
                <span
                  style="margin-left: 10px"
                >{{ scope.$index+1+(listData.pageIndex-1)*listData.pageSize }}</span>
              </template>
            </el-table-column>
            <el-table-column label="姓名">
              <template slot-scope="scope">
                <span>{{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column label="手机">
              <template slot-scope="scope">
                <span>{{scope.row.mobile}}</span>
              </template>
            </el-table-column>
            <el-table-column label="电话">
              <template slot-scope="scope">
                <span>{{scope.row.phone}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80" v-if="false">
              <template slot-scope="scope">
                <el-button-group>
                  <el-button size="mini" type="danger" @click="listDelete(scope.row)">删除</el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
          <div class="other-list-page">
            <el-pagination
              background
              layout="prev, pager, next"
              small="true"
              :page-size="listData.pageSize"
              :page-count="listData.totalPageCount"
              :total="listData.totalCount"
              :current-page.sync="listData.pageIndex"
              @current-change="listSearch()"
            ></el-pagination>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import publish_ from "@/components/publish"; //引用模块进来
import { getNbtxlGuardListData, delNbtxlGuardModelMothod } from "@/api/api";

export default {
  data() {
    return {
     
      user: {},
      listData: {
        pageIndex: 1,
        pageSize: 10,
        totalCount: 10,
        totalPageCount: 1,
        list: []
      }, //列表集合数据
      searchText: "" //查询内容
    };
  },
  //初始化数据
  mounted() {
    
    this.user = JSON.parse(window.localStorage.user);
    this.getListData();
  },
  methods: {
    //查询列表
    getListData() {
      var _this = this;
      var para = {
        params: {
          companyId: this.user.companyId,
          searchText: this.searchText,
          pageIndex: this.listData.pageIndex,
          pageSize: this.listData.pageSize
        }
      };
      getNbtxlGuardListData(para).then(res => {
        if (res.data.success) {
          _this.listData = res.data.data;
         
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //点击查询
    listSearch() {
    
      this.getListData();
    },

    //list点击删除
    listDelete(row) {
    
      var para = {
        params: { deptId: row.id }
      };
      delNbtxlDeptModelMothod(para).then(res => {
        if (res.data.success) {
          this.$message.success("删除成功");
          this.getListData();
        } else {
          this.$message.error(res.data.message);
        }
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/fksys/nbtxl/guard.vue